import * as ContactApi from 'saas/contacts/api';
import { createAction } from 'redux-actions';

export const fetchContactsAction = createAction('case.FETCH_CONTACTS');
export const fetchContactsSuccessAction = createAction(
  'case.FETCH_CONTACTS_SUCCESS'
);
export const selectContactAction = createAction('case.SELECT_CONTACT');
export const unselectContactAction = createAction('case.UNSELECT_CONTACT');
export const addContactAction = createAction('case.ADD_CONTACT');

export const fetchContacts = customer => (dispatch, getState) => {
  const state = getState();
  if (state.contacts.isFetching) {
    return Promise.resolve();
  }

  dispatch(fetchContactsAction());

  if (customer) {
    return ContactApi.getByCustomer(customer).then(response =>
      dispatch(fetchContactsSuccessAction(response))
    );
  } else {
    return dispatch(fetchContactsSuccessAction([]));
  }
};

export const selectContact = (site, contact) => (dispatch, getState) => {
  dispatch(
    selectContactAction({
      site,
      contact,
    })
  );
};

export const addContact = contact => (dispatch, getState) => {
  dispatch(addContactAction(contact));
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/cases-creation/step1/actions/contacts.js